/**
 * Class description
 *
 * Created: 2018-10-02
 * @author jonas
 */
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite, TweenLite} from "gsap";
import {DirtyWildsSpineAnimationNames} from "../../../config/DirtyWildsSpineAnimationNames";
import {DirtyWildsTextStyles} from "../../../config/DirtyWildsTextStyles";
import {DirtyWildsGameAssets} from "../../DirtyWildsGameAssets";
import {DirtyWildsSoundConfig} from "../../DirtyWildsSoundConfig";
import {MultiplierCounterDisplay} from "./parts/MultiplierCounterDisplay";


export class MultiplierMeterView extends PIXI.Container {
    private _counterDisplay:MultiplierCounterDisplay;
    private _dynamicText:PIXI.BitmapText;
    private _currentIndex:number;
    private _prevIndex:number;
    private _numberFire:PIXI.spine.Spine;
    //private _logoFire:PIXI.spine.Spine;
    private _showThreshold:number;
    private _active:boolean;
    private _currentMultiplier:number;

    constructor(threshold:number) {
        super();
        this._showThreshold = threshold;
        this._currentMultiplier = threshold;
        this._currentIndex = 0;
        this._prevIndex = 0;
        this._counterDisplay = new MultiplierCounterDisplay();
        this._counterDisplay.position.set(112, -171);

        this._dynamicText = new PIXI.BitmapText("x1", DirtyWildsTextStyles.TOP_BAR_NUMBER_STYLE);
        this._dynamicText.anchor = new PIXI.Point(0.5, 0.5);
        this._dynamicText.position.set(262, -171);
        this._dynamicText.alpha = 0;

        this._numberFire = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.TOP_BAR_NUMBER_FIRE));
        this._numberFire.position.set(258, -177);
        this.addChild(this._numberFire);
        this.addChild(this._counterDisplay);
        this.addChild(this._dynamicText);
    }

    private clearText() {
        this._dynamicText.alpha = 0;
        this._dynamicText.text = "";
    }

    private setText(value:number) {
        this._dynamicText.text = "x" + value;
    }


    private updateMultiplierAnimation(multiplier:number, isDouble:boolean):void {
        const tl:TimelineLite = new TimelineLite();
        if(this._active && multiplier <= this._showThreshold) {
            this._active = false;
            tl.add([
                this.getTurnOffAnimation(),
                this.getTextTickAnimation(multiplier)
            ]);
            this._currentMultiplier = multiplier;
        }

        if(!this._active && multiplier > this._showThreshold) {
            this._active = true;
            // tl.add(() => this.getTurnOnAnimation(isDouble));
        }

        if(multiplier != this._currentMultiplier) {
            tl.add(() => this.getTurnOnAnimation(isDouble));
            tl.add(this.getTextTickAnimation(multiplier));
            this._currentMultiplier = multiplier;
        }

    }

    private getTextTickAnimation(value:number) {
        const tl:TimelineLite = new TimelineLite();
        if(value <= this._showThreshold) {
            tl.add(() => this.clearText());
            return tl;
        }
        let scaleVale:number = value < 6 ? (1 + (value / 10)) : 1.6
        tl.add(() => this.setText(value));
        tl.add(new TweenLite(this._dynamicText, 0.01, {alpha : 0}));
        tl.set({}, {}, 0.2);
        tl.add(new TweenLite(this._dynamicText, 0.01, {alpha : 1}));
        tl.add(new TweenLite(this._dynamicText.scale, 0.01, {x : 1.75, y : 1.75}));
        tl.add(new TweenLite(this._dynamicText.scale, 0.4, {x : 1.75, y : 1.75}));
        tl.add(new TweenLite(this._dynamicText.scale, 0.1, {x : scaleVale, y : scaleVale}));
        return tl;
    }

    // public highlightLogo():TimelineLite{
    //     // middleCenter_normalTitleFire
    //     //
    //     //
    //     const tl:TimelineLite = new TimelineLite();
    //     tl.add(new SpineTween(this._logoFire, 0, "MayanMagicLogo"));
    //     return tl;
    // }

    public getUpdateTickAnimation(index:number, multiplier:number, isRestore:boolean, isDouble:boolean = false):TimelineLite {
        let tl:TimelineLite = new TimelineLite();

        if(index == this._currentIndex) {
            return tl;
        }
        tl.add(this.setMultiplierIndex(index, multiplier, isDouble, isRestore));

        this._currentIndex = index;
        return tl;
    }

    public updateMeterIndexOnWOW(index:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const meterIndex = index % 3;
        tl.add(this._counterDisplay.setNumberOfDots(meterIndex, false));
        return tl;
    }

    private setMultiplierIndex(index:number, multiplierControl:number, isDouble:boolean, isRestore:boolean):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.addLabel('targetPointZero', 0);
        tl.addLabel('targetPointOne', 0);
        tl.addLabel('targetPointTwo', 0.8);
        const meterIndex = index % 3;
        const prevMultiplier = Math.floor(this._prevIndex / 3) + 1;
        const multiplier = Math.floor(index / 3) + 1;
        const addedMultiplier:boolean = multiplier > prevMultiplier;


        if(addedMultiplier) {
            if(!isRestore) {
                tl.add(this._counterDisplay.setNumberOfDots(3, isDouble), 'targetPointZero');
            }
            tl.add(this._counterDisplay.setNumberOfDots(0, isDouble), tl.totalDuration() + 0.05);
            tl.add([
                () => SlotGame.sound.playEffect(DirtyWildsSoundConfig.MULTIPLIER_UP),
                () => this.updateMultiplierAnimation(multiplier, isDouble)
            ], 'targetPointOne');
        } else {
            tl.add(() => this.updateMultiplierAnimation(multiplier, isDouble));
            tl.add(this._counterDisplay.setNumberOfDots(meterIndex, isDouble));
        }


        if((multiplier) != multiplierControl) {
            //   throw new Error(`Multiplier error. Calculated ${(multiplier + 1)}, from server: ${multiplierControl}`);
            console.warn(`Multiplier error. Calculated ${(multiplier)}, from server: ${multiplierControl}`);
        }

        this._prevIndex = index;

        return tl;
    }


    private getTurnOnAnimation(isDouble:boolean):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let boxAnim:string = isDouble ? DirtyWildsSpineAnimationNames.TOP_BAR_MULTIPLIER_FIRE_START_GREEN : DirtyWildsSpineAnimationNames.TOP_BAR_MULTIPLIER_FIRE_START;
        tl.add(new SpineTween(this._numberFire, 0, boxAnim));
        tl.add(new SpineTween(this._numberFire, 0, DirtyWildsSpineAnimationNames.TOP_BAR_MULTIPLIER_FIRE_LOOP, -1));
        return tl;
    }

    private getTurnOffAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new SpineTween(this._numberFire, 0, DirtyWildsSpineAnimationNames.TOP_BAR_MULTIPLIER_FIRE_STOP));
        return tl;
    }


}